import * as z from 'zod';
import * as Result from '$lib/utils/result';

export const jsonLiteral = z.union([z.string(), z.number(), z.boolean(), z.null()]);
export type JsonLiteral = z.infer<typeof jsonLiteral>;

export type JsonObject = { [Key in string]?: JsonValue } & {
    [Key in string]?: JsonValue | undefined;
};
export type JsonArray = JsonValue[];
export type JsonValue = JsonLiteral | JsonObject | JsonArray;

export const jsonObject = z.lazy(() => {
    return z.record(jsonValue);
});

export const jsonArray = z.lazy(() => {
    return z.array(jsonValue);
});

export const jsonValue: z.ZodType<JsonValue> = z.lazy(() =>
    z.union([jsonLiteral, jsonArray, jsonObject]),
);

export function safeParse<Output, Def extends z.ZodTypeDef, Input = Output>(
    schema: z.ZodType<Output, Def, Input>,
    data: unknown,
): Result.Result<Output, z.ZodError> {
    return Result.fromSafeZod(schema.safeParse(data));
}

export async function safeParseAsync<Output, Def extends z.ZodTypeDef, Input = Output>(
    schema: z.ZodType<Output, Def, Input>,
    data: unknown,
): Promise<Result.Result<Output, z.ZodError>> {
    return Result.fromSafeZod(await schema.safeParseAsync(data));
}

export function safeParseJson(json: string): Result.Result<JsonValue, z.ZodError> {
    return safeParse(jsonValue, JSON.parse(json) as unknown);
}

export function safeParseJsonObject(json: string): Result.Result<JsonObject, z.ZodError> {
    return safeParse(jsonObject, JSON.parse(json) as unknown);
}
